import React from "react";
import { useTranslation } from "react-i18next";
import { galleryStore } from "gallery/_store/GalleryStore";
import { Button } from "_common/ui/mui/buttons/Button";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { TUnitListingMdl } from "admin/units/_models/UnitListingMdl";
import { TUnitTypeListingMdl } from "units/_models/UnitTypeMdl";

type Props = {
    unit: TUnitListingMdl | TUnitTypeListingMdl;
    title: string;
    scrollToInventory?: () => void;
    scrollToFloorPlan: () => void;
    scrollToChecklist: () => void;
};

export function UnitScrollButtons({ unit, title, scrollToInventory, scrollToFloorPlan, scrollToChecklist }: Props) {
    const { t } = useTranslation();

    if (!unit.features && unit.floorPlans) return null;
    return (
        <div className="flex gap-4 mb-10 flex-wrap">
            <Button
                variant={"contained"}
                color={"primary"}
                className={"w-full md:w-52 !py-2.5"}
                onClick={() =>
                    galleryStore.openContactForm({
                        resource: COMMON_RESOURCE.UNIT,
                        title: title,
                        unitId: unit._id,
                    })
                }
            >
                {t("property.galleryNavbar.contact")}
            </Button>
            {scrollToInventory && (
                <Button
                    color={"primary"}
                    variant={"outlined"}
                    className={"w-full md:w-52 !py-2.5"}
                    onClick={scrollToInventory}
                >
                    {t("unit.inventoryTitle")}
                </Button>
            )}
            {unit.features && (
                <Button
                    color={"primary"}
                    variant={"outlined"}
                    className={"w-full md:w-52 !py-2.5"}
                    onClick={scrollToChecklist}
                >
                    {t("unit.featuresTitle")}
                </Button>
            )}
            {!!unit.floorPlans && unit.floorPlans.length > 0 && (
                <Button
                    color={"primary"}
                    variant={"outlined"}
                    className={"w-full md:w-52 !py-2.5"}
                    onClick={scrollToFloorPlan}
                >
                    {scrollToInventory ? t("propertyPage.floorPlan") : t("propertyPage.floorPlanUnit")}
                </Button>
            )}
        </div>
    );
}

export default UnitScrollButtons;
